export default "__VITE_PUBLIC_ASSET__e1102ab2__"